module.exports = __webpack_public_path__ + "static/img/banner1.60e9c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tecSystem/banner1.jpg
// module id = w+ad
// module chunks = 0